import { theme } from "rimble-ui";

export const customTheme = {
  ...theme,
  primaryDark: "#0D0C1D",
  primaryLight: "#EFFFFA",
  primaryHover: "#343078",
  mobile: "576px",
};
